import { ReactNode } from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { formatCasePack, formatUnitNetWeight } from "components/Products/utils";

const fragment = gql(/* GraphQL */ `
  fragment SkuPackSize on Sku {
    id
    unitNetWeight
    unitNetWeightUnit
    productLine {
      id
      wholesaleCaseQuantity
      innerCaseQuantity
    }
  }
`);

type Props = BoxProps & {
  fallback?: ReactNode;
  sku: FragmentType<typeof fragment>;
};

export default function SkuPackSize({
  fallback = null,
  sku: skuFragment,
  ...boxProps
}: Props) {
  const sku = getFragmentData(fragment, skuFragment);

  const casePack =
    formatCasePack(
      sku.productLine?.wholesaleCaseQuantity,
      sku.productLine?.innerCaseQuantity,
    ) || "";

  const unitNetWeight = formatUnitNetWeight(
    sku.unitNetWeight,
    sku.unitNetWeightUnit,
  );

  if (!casePack && !unitNetWeight) return fallback;

  return (
    <Box {...boxProps}>
      {casePack}
      {casePack && !unitNetWeight && " pack"}
      {casePack && unitNetWeight ? `/` : ""}
      {unitNetWeight}
    </Box>
  );
}
